
















































import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/dataZoom/DataZoomModel'
import 'echarts/lib/component/dataZoomInside'
import 'echarts/lib/component/dataZoomSlider'
import 'echarts/lib/component/dataZoomSelect'
import 'echarts/lib/component/legend'

import { Query, Item } from '@/types/data-log'

import Mixins from './mixin'
import moment from 'moment'

import { QueryRecordedData } from '@/api/data-logger'

import { TrendSeries, Field, SeriesData } from './types'
// import template from '@/apps/cems/report/template.vue'

export default Mixins.extend({
  // components: { template },
  name: 'TrendingLinePanel',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      statusBusy: false,
      destroyed: false,

      options: {
        animation: false,
        legend: {},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false,
          },
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: true,
          },
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitNumber: 10,
          splitLine: {
            lineStyle: {
              color: '#999',
            },
          },
          axisLabel: {
            show: true,
          },
          minorSplitLine: {
            show: true,
            lineStyle: {
              color: '#ddd',
            },
          },
        },
        series: [] as TrendSeries[],
      },
    }
  },

  computed: {
    fields(): Field[] {
      return [
        { key: 'n', label: '#' },
        { key: 'time', label: 'Timestamp' },
        ...this.dataLoggerItems.map((item: Item) => {
          return { key: item.tagUID, label: item.name }
        }),
      ]
    },
  },

  methods: {
    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    // Initialization
    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    initForm() {
      const sub = this.model.attributes.form.duration.split(' ')
      this.form.startDate = moment()
        .subtract(sub[0], sub[1])
        .format('YYYY-MM-DD')
      this.form.startTime = moment()
        .subtract(sub[0], sub[1])
        .format('HH:mm:ss')

      this.form.endDate = moment().format('YYYY-MM-DD')
      this.form.endTime = moment().format('HH:mm:ss')
    },

    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    // Recorded data operation
    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    async queryRecordedData(q: Query) {
      const Results = await QueryRecordedData([q])

      if (Results.length < 1) {
        return
      }

      const results = Results[0]

      if (results.length < 2) {
        this.form.rowsCount = 0
        return
      }

      // Series pertama adalah data
      const dataResult = results[0]
      // Series terakhir adalah jumlah record
      const countResult = results[1]

      if (!Array.isArray(dataResult.Series)) {
        this.form.rowsCount = 0
        return
      }

      if (!Array.isArray(countResult.Series)) {
        this.form.rowsCount = 0
        return
      }
      if (countResult.Series.length > 0) {
        this.form.rowsCount = countResult.Series[0].values[0][1]
      }

      const seriesCount = dataResult.Series.length
      if (seriesCount < 1) return

      const valuesCount = dataResult.Series[0].values.length
      const columns = dataResult.Series[0].columns

      const series = dataResult.Series[0]

      interface MapSeries {
        [tagUID: string]: TrendSeries
      }

      const trendSeries: MapSeries = {}

      for (let index = 0; index < this.model.attributes.query.length; index++) {
        const f = this.model.attributes.query[index]

        trendSeries[f.measurement] = {
          name: f.name,
          tag: f.measurement,
          type: 'line',
          color: f.color,
          smooth: true,
          hoverAnimation: false,
          showSymbol: false,
          data: [] as SeriesData[],
        } as TrendSeries
      }

      for (let valueIndex = 0; valueIndex < valuesCount; valueIndex++) {
        for (let columnIndex = 1; columnIndex < columns.length; columnIndex++) {
          const columnName = columns[columnIndex]

          trendSeries[columnName].data.push([
            series.values[valueIndex][0],
            series.values[valueIndex][columnIndex],
          ])
        }
      }

      this.options.series = []
      for (const tagUID in trendSeries) {
        this.options.series.push(trendSeries[tagUID])
      }
    },

    async readRecord() {
      if (this.model.attributes.form.dataLoggerId == -1) {
        return
      }

      this.statusBusy = true

      try {
        // const timeFormat = 'YYYY-MM-DDTHH:mm:ss'

        const sub = this.model.attributes.form.duration.split(' ')
        const timeStart = moment()
          .subtract(sub[0], sub[1])
          .toDate()

        const timeEnd = new Date()

        const fields: string[] = []
        for (let i = 0; i < this.model.attributes.query.length; i++) {
          fields.push(this.model.attributes.query[i].measurement)
        }

        const q: Query = {
          dataLoggerId: this.model.attributes.form.dataLoggerId,
          timeStart,
          timeEnd,
          fields,
          limit: this.model.attributes.form.limit,
          offset: (this.form.currentPage - 1) * this.form.limit,
          resolution: this.model.attributes.form.resolution,
        }

        await this.queryRecordedData(q)
      } catch {
        this.$toast.error('Failed to read recorded data.')
      }
      this.statusBusy = false
    },

    async cyclicUpdate() {
      try {
        await this.readRecord()
      } catch {
        //
      }

      // eslint-disable-next-line
      ;(this as any).tmrCyclicUpdate = setTimeout(() => {
        if (!this.destroyed) {
          this.cyclicUpdate()
        }
      }, 3000)
    },

    //---------------------------------------------------------------------------------------------------------------------------
    // Toolbar events
    //---------------------------------------------------------------------------------------------------------------------------
    async onToolbarShow() {
      this.options.series = []
      // eslint-disable-next-line
      ;(this as any).$refs.echarts.clear()
      await this.readRecord()
    },
  },

  async created() {
    this.initForm()

    this.parseInput()
    this.options = Object.assign(
      this.options,
      this.value.attributes.chartOptions
    )

    if (this.model.attributes.updateOnPageOpen) {
      await this.cyclicUpdate()
    }
  },

  beforeDestroy() {
    this.destroyed = true
    // eslint-disable-next-line
    clearTimeout((this as any).tmrCyclicUpdate)
  },
})
